import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAuthentication } from '../customHooks/useAuthentication'
import { isSuperAdminUser } from '../views/Dashboard/saasAdmin.utils'
import paths from './paths'

export default function SuperAdminRoute({ children, currentToken }) {
  const { userInfo } = useAuthentication()
  if (!currentToken) {
    return <Redirect to="/login" />
  }
  if (!isSuperAdminUser(userInfo)) {
    return <Redirect to={paths.dashboard} />
  }
  return children
}
